import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  myLabelClass: {
    fontSize: "10px",
    fontWeight: 700,
    lineHeight: "13px",
    letterSpacing: "0%",
    textAlign: "center",
    textOverflow: "inherit",
    padding: 0
  }
}));
export interface BadgeProps {
  label: string;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ label, className }) => {
  const classes = useStyles();

  return (
    <Chip
      label={label}
      className={className}
      sx={{
        height: 19,
        maxWidth: 70,
        borderRadius: 10,
        padding: "1px 5px 2px 5px"
      }}
      classes={{ label: classes.myLabelClass }}
    />
  );
};

export default Badge;
